
import React from 'react';
import { render } from 'react-dom';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Scroll from 'react-scroll';
import ThomasImage from '../images/ThomasImage.png';
import Button from "react-bootstrap/Button";
import StarImage from '../images/StarImage.png';
import CommentOutline from '../images/CommentOutline.png';
import JosephImage from '../images/JosephImage.png';
import MarcusImage from '../images/MarcusImage.png';
import MargaretImage from '../images/MargaretImage.png';
import FrankImage from '../images/FrankImage.png';
var Element = Scroll.Element;
var Events = Scroll.Events;
var scroll = Scroll.animateScroll;
var scrollSpy = Scroll.scrollSpy;
class Section extends React.Component {
    constructor(props) {
        super(props);
        this.scrollToTop = this.scrollToTop.bind(this);
    }
    componentDidMount() {
        Events.scrollEvent.register('begin', function () {
            console.log("begin", arguments);
        });
        Events.scrollEvent.register('end', function () {
            console.log("end", arguments);
        });
        scrollSpy.update();
    }
    scrollToTop() {
        scroll.scrollToTop();
    }
    componentWillUnmount() {
        Events.scrollEvent.remove('begin');
        Events.scrollEvent.remove('end');
    }
    render() {
        return (
            <div>
                <nav className="navbar navbar-default navbar-fixed-top">
                    <div className="container-fluid">
                        <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                            <ul className="nav navbar-nav">
                            </ul>
                        </div>
                    </div>
                </nav>
                <Element name="test7" className="element" id="containerElement" style={{
                    position: 'relative',
                    height: '350px',
                    overflow: 'scroll',
                    marginBottom: '10px',
                    paddingLeft: '20px',
                    paddingRight: '20px'
                }}>
                    <Element name="firstInsideContainer" style={{
                        marginBottom: '10px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}>
                        <Row>
                            <Col>
                                <img src={ThomasImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <Row>
                                    <span style={{
                                        fontFamily: 'Sintony',
                                        fontSize: '11px',
                                        fontWeight: '400',
                                        lineHeight: '18.24px',
                                        color: '#475666',
                                    }}>
                                        Thomas H.
                                        Chicago, IL
                                    </span>
                                </Row>
                                <Row> <div>
                                    <div style={{
                                        fontSize: '11px',
                                        color: '#3786C3',
                                        width: '82px'
                                    }}>
                                        <img src={StarImage} style={{ width: '12px', height: '11px' }} alt="" />  YOUR EXPERT
                                    </div>
                                </div>
                                </Row>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                    </Element>
                    <hr></hr>
                    <Element id="same" className="element" style={{
                        marginBottom: '5px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}>
                        <Row>
                            <Col>
                                <img src={JosephImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Joseph S.
                                    New York, NY
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                    </Element>
                    <hr></hr>
                    <Element name="secondInsideContainer" style={{
                        marginBottom: '5px',
                        paddingLeft: '20px',
                        paddingRight: '20px'
                    }}>
                        <Row>
                            <Col>
                                <img src={MarcusImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Marcus L.
                                    Boston, MA
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={MargaretImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Margaret M.
                                    Chicago, IL
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={FrankImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >

                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Frank S.
                                    Chicago, IL
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={FrankImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Frank S.
                                    Chicago, IL
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={FrankImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Frank S.
                                    Chicago, IL
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={FrankImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >

                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Frank S.
                                    Chicago, IL
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                        <hr></hr>
                        <Row>
                            <Col>
                                <img src={FrankImage} style={{ width: '', height: '', borderRadius: '50%' }} alt="" />
                            </Col>
                            <Col >
                                <span style={{
                                    fontFamily: 'Sintony',
                                    fontSize: '11px',
                                    fontWeight: '400',
                                    lineHeight: '18.24px',
                                    color: '#475666',
                                }}>
                                    Frank S.
                                    Chicago, IL
                                </span>
                            </Col>
                            <Col>
                                <Button variant="outline-secondary" size="lg" type="submit" style={{
                                    height: '43px',
                                    width: '100px',
                                    fontSize: '12px',
                                    borderRadius: '0',
                                    color: '#979797',
                                    borderColor: '#979797',
                                }} >
                                    <img src={CommentOutline} style={{ width: '19px', height: '17px' }} alt="" />   CHAT
                                </Button>
                            </Col>
                        </Row>
                    </Element>
                </Element>
            </div>
        );
    }
};

export default Section;
render(<Section />, document.getElementById('root'));
